import React, { useState } from 'react';
import { FaUserAlt } from "react-icons/fa";
import { RiMoneyEuroCircleFill, RiFileExcelLine } from "react-icons/ri";
import { TextField, Box, Button } from '@mui/material';
import dayjs from 'dayjs';

const PaidGuests = ({ guests, searchTerm, onSearchChange, onExportClick, onGameClick }) => {
    const [expandedGuest, setExpandedGuest] = useState(null);

    const handleToggleGuest = (guestId) => {
        setExpandedGuest(prevExpandedGuest => prevExpandedGuest === guestId ? null : guestId);
    };

    return (
        <div className='bg-white rounded px-3 pb-3 pt-3 shadow'>
            <div className='row align-items-center text-center'>
                <div className='col-12 fs-5 fw-semibold text-danger pb-3'>Bezahlte Gaststunden</div>

                <div className='col-12 mt-3'>
                    <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', alignItems: 'center' }}>
                        <TextField
                            label="Suche..."
                            variant="outlined"
                            value={searchTerm}
                            onChange={onSearchChange}
                            size="small"
                            sx={{ flexGrow: 1, maxWidth: '300px' }}
                        />
                        
                        <Button
                            variant="outlined"
                            color="success"
                            startIcon={<RiFileExcelLine />}
                            onClick={onExportClick}
                            sx={{ 
                                color: '#1D6F42', 
                                borderColor: '#1D6F42',
                                '&:hover': {
                                    borderColor: '#155231',
                                    bgcolor: 'rgba(29, 111, 66, 0.04)'
                                }
                            }}
                        >
                            Export
                        </Button>
                    </Box>
                </div>
            </div>

            <div className='row my-2 align-items-center py-2 text-center'>
                <div className='col-6 col-md-4 infotext'><FaUserAlt size={22} /></div>
                <div className='col-3 col-md-4 infotext d-none d-md-block'>Buchungen</div>
                <div className='col-3 col-md-4 infotext'><RiMoneyEuroCircleFill size={22} /></div>
            </div>

            {guests.map((guest, index) => (
                <div key={index} className='row my-2 align-items-center border-bottom py-3 text-center'>
                    <div className={`col-6 col-md-4 fs-7 ${expandedGuest === guest.id && 'fw-semibold'}`} 
                         onClick={() => handleToggleGuest(guest.id)} 
                         style={{ cursor: 'pointer' }}>
                        {guest.name}
                    </div>
                    <div className='col-3 col-md-4 d-none d-md-block fs-7'>{guest.games.length}</div>
                    <div className='col-3 col-md-4 fs-7 d-flex align-items-center justify-content-center gap-1'>
                        {guest.amount}
                    </div>

                    {expandedGuest === guest.id && (
                        <div className='col-12'>
                            {guest.games.map((game, gameIndex) => (
                                <div 
                                    key={gameIndex} 
                                    className='row my-1 align-items-center py-2 text-center shadow-sm rounded-5 booking interactive-row'
                                    onClick={() => onGameClick && onGameClick(game.id)}
                                    style={{ cursor: 'pointer' }}
                                >
                                    <div className='col-3 col-md-2 fs-7'>{dayjs(game.date).format("DD.MM.YYYY")}</div>
                                    <div className='col-3 col-md-2 fs-7'>{game.type === "single" ? "Einzel" : "Doppel"}</div>
                                    <div className='col-2 col-md-2 fs-7'>{game.hours} h</div>
                                    <div className='col-2 col-md-2 fs-7'>{game.rate} €</div>
                                    <div className='col-2 col-md-4 icon-paid d-flex justify-content-center align-items-center fs-7 gap-1'> 
                                        <RiMoneyEuroCircleFill size={20} />
                                        <span className="d-none d-md-inline">{dayjs(game.payDate).format("DD.MM.YYYY")}</span>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            ))}
        </div>
    );
};

export default PaidGuests;
